import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group, Pagination, Text } from "@mantine/core";

import "./pagination.css";

interface ISSPaginationProps {
  currentPage: number;
  pageCount: number;
  itemsPerPage: number;
  itemsCount: number;
  onPaginate: (page: number) => void;
  classNames?: {
    root?: string;
  };
}

const SSPagination: React.FC<ISSPaginationProps> = ({
  currentPage,
  pageCount,
  itemsPerPage,
  itemsCount,
  onPaginate,
  classNames,
}) => {
  const { t } = useAppTranslation("common.pagination");
  const toCount =
    itemsCount > itemsPerPage
      ? Math.min(itemsCount, currentPage * itemsPerPage)
      : itemsCount;

  const fromCount =
    toCount === 0
      ? 0
      : Math.max(Math.max(currentPage - 1, 0) * itemsPerPage + 1, 0);

  return (
    <Group
      className={`w-full ${classNames?.root}`}
      gap={0}
      justify="space-between"
      m={0}
      p={0}
    >
      <Text className="hidden text-primary-light-text md:block">
        <strong>{fromCount}</strong> {t("to")} <strong>{toCount}</strong>{" "}
        {t("of")} <strong>{itemsCount}</strong> {t("results")}
      </Text>
      <Pagination
        className="w-full md:w-auto"
        classNames={{
          control:
            "bg-primary-default hover:bg-primary-default text-primary-light-text border-primary-lighter data-[active=true]:bg-primary-lighter",
          dots: "text-primary-lighter",
          root: "flex justify-center",
        }}
        total={pageCount}
        value={currentPage}
        onChange={onPaginate}
      />
    </Group>
  );
};

export default SSPagination;
